import { render } from "./Start.vue?vue&type=template&id=7ef0623e&bindings={\"loading\":\"data\",\"response\":\"data\",\"form_schema\":\"data\",\"submit\":\"options\"}"
import script from "./Start.vue?vue&type=script&lang=js"
export * from "./Start.vue?vue&type=script&lang=js"

import "./Start.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script